namespace PaperTrail.NewsletterControl {
    export interface PageTemplateRow {
        PageTemplateId?: number;
        Title?: string;
        FileName?: string;
        IsFrontPage?: boolean;
        Rank?: number;
        AdsSpots?: number;
        NewsSpots?: number;
        IsFilled?: boolean;
        TemplateSections?: PageTemplateSectionRow[];
    }

    export namespace PageTemplateRow {
        export const idProperty = 'PageTemplateId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'NewsletterControl.PageTemplate';
        export const lookupKey = 'NewsletterControl.PageTemplate';

        export function getLookup(): Q.Lookup<PageTemplateRow> {
            return Q.getLookup<PageTemplateRow>('NewsletterControl.PageTemplate');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            PageTemplateId = "PageTemplateId",
            Title = "Title",
            FileName = "FileName",
            IsFrontPage = "IsFrontPage",
            Rank = "Rank",
            AdsSpots = "AdsSpots",
            NewsSpots = "NewsSpots",
            IsFilled = "IsFilled",
            TemplateSections = "TemplateSections"
        }
    }
}
